import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-missing-page',
  imports: [
    RouterOutlet
  ],
  templateUrl: './missing-page.component.html',
  styleUrl: './missing-page.component.css'
})
export class MissingPageComponent {

}
